import React from 'react'

const PageNotFound = () => <p>Page not found</p>

export default PageNotFound
